module.exports = __webpack_public_path__ + "img/img-hoteles.e640897d.webp";